import { render, staticRenderFns } from "./editorTool.vue?vue&type=template&id=68fb6bcd&scoped=true"
import script from "./editorTool.vue?vue&type=script&lang=js"
export * from "./editorTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fb6bcd",
  null
  
)

export default component.exports